import PropTypes from 'prop-types';
import { alpha, useTheme } from '@mui/material/styles';
import { Card, Box, Typography, CardHeader } from '@mui/material';
import CountUp from 'react-countup';

MiniWidgetSummary.propTypes = {
    color: PropTypes.string,
    title: PropTypes.string.isRequired,
    subheader: PropTypes.string.isRequired,
    total: PropTypes.number.isRequired,
    sx: PropTypes.object,
};

export default function MiniWidgetSummary({ title, subheader, total, color = 'primary', sx, ...other }) {
    const theme = useTheme();

    return (
        <Card
            sx={{
                py: 1,
                color: (theme) => (theme.palette.mode === 'light' ? theme.palette[color].darker : theme.palette[color].light),
                bgcolor: (theme) => (theme.palette.mode === 'light' ? "white" : '#1F1F1F'),
                '&:hover': {
                    boxShadow: theme.shadows[5],
                },
                boxShadow: `
        -8px -8px 10px ${alpha(theme.palette.primary.darker, 0.05)},
        8px 8px 5px ${alpha(theme.palette.primary.darker, 0.025)}
      `,
                ...sx,
            }}
            {...other}
        >
            <Box sx={{ display: 'flex', justifyContent: 'space-around' }}>
                <CardHeader title={title} subheader={subheader} />
                <Typography variant="h3" sx={{ pr: 2, display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
                    <CountUp end={total} duration={3} separator="," />
                </Typography>
            </Box>
        </Card>
    );
}
